import * as React from 'react';
import { Container } from 'react-bootstrap';

function AboutUs() {

    return <>
        <Container className="mt-5 d-flex align-items-center justify-content-center about-page-shell" fluid="lg">
            {/* <ul>
                <li>Aabith Toufeek - Reviewer</li>
                <li>Anisa Mariyam H - Archivist of Revelation</li>
                <li>Ibrahim Vasanth - Site developer and owner</li>
            </ul> */}
            <div className="banner">
                <div className="banner-content">
                    <h1>Credits</h1>
                    <p>Aabith Toufeek – <span className="role">Reviewer</span></p>
                    <p>Anisa Mariyam H – <span className="role">Knowledge Curator</span></p>
                    <p>Ibrahim Vasanth – <span className="role">Site Developer</span></p>
                    {/* <a href="#" className="cta-button">Learn More</a> */}
                </div>
            </div>
        </Container>

    </>
}

export default AboutUs;
